/**
 * WizardStep4Done — Krok 4: Gotowe + podsumowanie.
 *
 * Props:
 *   - savedNip (string)
 *   - adminConfig (object)
 *   - onFinish (callback)  — przycisk "Zakończ" / "Przejdź do faktur"
 *   - onEdit (callback)    — przycisk "Edytuj" wraca do kroku 1
 */
import { CheckCircle, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export const WizardStep4Done = ({ savedNip, adminConfig, onFinish, onEdit }) => {
  const maskedNip = savedNip
    ? `${savedNip.slice(0, 3)}***${savedNip.slice(-4)}`
    : "—";

  return (
    <div className="space-y-6" data-testid="wizard-step4">
      <div className="text-center py-4">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-3">
          <Sparkles className="w-8 h-8 text-green-600" />
        </div>
        <h2 className="text-xl font-semibold text-[#0F1F3D]">Konfiguracja zakończona</h2>
        <p className="text-sm text-gray-600 mt-1">
          Twoja aplikacja jest połączona z Krajowym Systemem e-Faktur.
        </p>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-4 space-y-2">
        <p className="text-sm font-medium text-green-900 mb-2">Podsumowanie konfiguracji:</p>
        <div className="text-sm space-y-1.5">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0" />
            <span className="text-gray-700">NIP podmiotu:</span>
            <span className="font-mono font-medium text-gray-900">{maskedNip}</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0" />
            <span className="text-gray-700">Środowisko:</span>
            <span className="font-medium text-gray-900">PRODUKCJA (ksef.mf.gov.pl)</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0" />
            <span className="text-gray-700">Certyfikat:</span>
            <span className="font-medium text-gray-900">
              {adminConfig?.has_cert ? "Zapisany" : "—"}
              {adminConfig?.cert_filename && (
                <span className="text-xs text-gray-500 ml-1">({adminConfig.cert_filename})</span>
              )}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0" />
            <span className="text-gray-700">Test mTLS:</span>
            <span className="font-medium text-green-700">Poprawny</span>
          </div>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <p className="text-xs text-blue-700">
          <strong>Co dalej?</strong> Przejdź do zakładki „Faktury" i kliknij „Pobierz z KSeF",
          aby pobrać swoje pierwsze dokumenty z Krajowego Systemu e-Faktur.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          onClick={onFinish}
          className="flex-1"
          data-testid="wizard-finish-btn"
        >
          Zakończ i przejdź do panelu
        </Button>
        <Button
          onClick={onEdit}
          variant="outline"
          className="flex-1"
          data-testid="wizard-edit-btn"
        >
          Edytuj ustawienia
        </Button>
      </div>
    </div>
  );
};

export default WizardStep4Done;
